<template>
    <div id="settings-page">
        <loader v-if="is('loading')"></loader>
        <div class="container-fluid" v-if="is('ready')">
            <div class="row">
                <div class="col-md-12 col-sm-12">
                    <div class="box clearfix">
                        <h1>{{ t('notificationSchedule-title') }}</h1>

                        <p v-if="hasCopied">
                            {{ t('notificationSchedule-copy_instruction') }}
                        </p>
                        <p v-else>
                            {{ t('notificationSchedule-main_description') }}
                        </p>

                        <template v-if="hasCopied">
                            <div class="">
                                <div class="p-2">
                                    <label>
                                        <input
                                            type="checkbox"
                                            v-model="
                                                notification_schedule_select_all
                                            "
                                        />
                                        {{ t('notificationSchedule-all') }}
                                    </label>
                                </div>

                                <div
                                    class="p-2"
                                    v-for="(
                                        value, day
                                    ) in notification_schedule_selecteds"
                                    :key="day"
                                >
                                    <label>
                                        <input
                                            type="checkbox"
                                            v-model="
                                                notification_schedule_selecteds[
                                                    day
                                                ]
                                            "
                                        />
                                        {{ t(days_of_the_week[day]) }}
                                    </label>
                                </div>
                            </div>

                            <div>
                                <button
                                    class="btn btn-success pull-right"
                                    :disabled="!hasSelection"
                                    @click.prevent="copySelection()"
                                >
                                    {{ t('notificationSchedule-copy') }}
                                </button>
                                <button
                                    class="btn btn-secondary pull-right mr-2"
                                    :disabled="copied === null"
                                    @click.prevent="resetSelection()"
                                >
                                    {{ t('notificationSchedule-cancel') }}
                                </button>
                            </div>
                        </template>
                        <template v-else>
                            <notification-schedule-day
                                v-for="(value, day) in notification_schedule"
                                :key="day"
                                v-model="notification_schedule[day]"
                                @copy="setTimeCopied($event)"
                            >
                                {{ t(days_of_the_week[day]) }}
                            </notification-schedule-day>

                            <div>
                                <button
                                    class="btn btn-success pull-right"
                                    :disabled="!isValid"
                                    @click.prevent="save()"
                                >
                                    <span
                                        class="fa fa-spin fa-spinner"
                                        v-if="is('saving')"
                                    ></span>
                                    {{ t('notificationSchedule-save') }}
                                </button>
                                <button
                                    class="btn btn-secondary pull-right mr-2"
                                    :disabled="!isModified"
                                    @click.prevent="reset()"
                                >
                                    {{ t('notificationSchedule-cancel') }}
                                </button>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import keviApi from "../keviApi";
import notificationSchedulDay from "./notification-schedule-day.vue";
export default {
    components: {
        "notification-schedule-day": notificationSchedulDay,
    },
    data() {
        return {
            state: "loading",
            copied: null,
            notification_schedule_selecteds: {
                sunday: false,
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
            },
            notification_schedule_select_all: false,
            notification_schedule: {
                sunday: [],
                monday: [],
                tuesday: [],
                wednesday: [],
                thursday: [],
                friday: [],
                saturday: [],
            },
            days_of_the_week: {
                sunday: "notificationSchedule-days-sunday",
                monday: "notificationSchedule-days-monday",
                tuesday: "notificationSchedule-days-tuesday",
                wednesday: "notificationSchedule-days-wednesday",
                thursday: "notificationSchedule-days-thursday",
                friday: "notificationSchedule-days-friday",
                saturday: "notificationSchedule-days-saturday",
            },
            notification_schedule_start: null,
            is_modified: false,
        };
    },
    computed: {
        place() {
            return this.$store.state.place;
        },
        isModified() {
            return this.is_modified;
        },
        isValid() {
            return !(this.remainingChars < 0 || this.saving) && this.isModified;
        },
        hasCopied() {
            return this.copied != null;
        },
        hasSelection() {
            return Object.values(this.notification_schedule_selecteds).some(
                (s) => s === true,
            );
        },
    },
    watch: {
        notification_schedule: {
            deep: true,
            handler() {
                if (this.notification_schedule && this.copied) {
                    const allIsequals = Object.values(
                        this.notification_schedule || {},
                    ).every(
                        (ns) =>
                            JSON.stringify(this.copied) === JSON.stringify(ns),
                    );
                    this.copied = !allIsequals ? this.copied : null;
                }
                this.is_modified =
                    JSON.stringify(this.notification_schedule_start) !==
                    JSON.stringify(this.notification_schedule);
            },
        },
        notification_schedule_select_all() {
            Object.keys(this.notification_schedule_selecteds).forEach(
                (day) =>
                    (this.notification_schedule_selecteds[day] =
                        this.notification_schedule_select_all),
            );
        },
    },
    methods: {
        t: function (term, replaces) {
            return this.$root.t(term, replaces);
        },
        is: function (state) {
            return this.state === state;
        },
        setState: function (state) {
            this.state = state;
        },
        setTimeCopied(time = null) {
            if (time) {
                this.copied = JSON.parse(JSON.stringify(time));
                this.$store.dispatch("notification/success", {
                    text: this.t("notificationSchedule-success_copy"),
                    duration: 3000,
                });
                return;
            }
            this.resetTimeCopied();
        },
        resetTimeCopied() {
            this.copied = null;
        },
        resetTime(day = null) {
            this.notification_schedule[day] = [];
        },
        selectTimeItem(event) {
            this.notification_schedule_selecteds[event.day_of_week] =
                event.selected;
        },
        getForm: function () {
            this.setState("loading");
            var options = keviApi.getOptions("settings");
            this.$http(options).then((response) => {
                try {
                    let schedule = JSON.parse(
                        response.body.notification_schedule,
                    );
                    if (schedule) {
                        Object.assign(this.notification_schedule, schedule);
                    }
                } catch (e) {}
                this.notification_schedule_start = JSON.parse(
                    JSON.stringify(this.notification_schedule),
                );
                this.setState("ready");
            });
            setTimeout(() => this.setState("ready"), 10000);
        },
        getFilteredSchedule() {
            var filtered_schedule = {};
            Object.keys(this.notification_schedule).forEach((key) => {
                filtered_schedule[key] = this.notification_schedule[key];
                if (this.notification_schedule[key]) {
                    filtered_schedule[key] = this.notification_schedule[key]
                        .map((sc) => (sc[0] && sc[1] ? sc : null))
                        .filter((sc) => sc?.length);
                    if (filtered_schedule[key].length === 0) {
                        filtered_schedule[key] = [];
                    }
                }
            });
            return filtered_schedule;
        },
        save: function () {
            var options = keviApi.getOptions(
                "settings/notification-schedule",
                "POST",
                {
                    notification_schedule: JSON.stringify(
                        this.getFilteredSchedule(),
                    ),
                },
            );
            this.setState("saving");

            this.$http(options)
                .then((response) => {
                    this.setState("ready");
                    if (response.status === 200 && response.body.status === "success") {
                        this.notification_schedule_start = JSON.parse(
                            JSON.stringify(this.notification_schedule),
                        );
                        this.is_modified = false;
                        this.$store.dispatch("notification/success", {
                            text: this.t("notificationSchedule-success_update"),
                            duration: 3000,
                        });
                        window?.mixpanel?.track(
                            "Settings - save notification schedule",
                            {
                                notification_schedule:
                                    this.notification_schedule,
                                places_id: this.place.id,
                            },
                        );
                    } else {
                        const message =
                            response.body?.message === "lifetime-too-short"
                                ? this.t("notificationSchedule-error_save")
                                : response.body?.message || this.t("notificationSchedule-error_save");
                        this.$store.dispatch("notification/error", {
                            text: message,
                            duration: 5000,
                        });
                    }
                })
                .catch(() => {
                    this.setState("ready");
                    this.$store.dispatch("notification/error", {
                        text: this.t("notificationSchedule-error_save"),
                        duration: 5000,
                    });
                });
            setTimeout(() => this.setState("ready"), 10000);
        },
        reset() {
            this.notification_schedule = Object.assign(
                {},
                this.notification_schedule_start,
            );
        },
        copySelection() {
            if (this.hasSelection && this.hasCopied) {
                Object.keys(this.notification_schedule).forEach((day) => {
                    if (
                        this.notification_schedule_selecteds[day] ||
                        this.notification_schedule_select_all
                    ) {
                        this.notification_schedule[day] = JSON.parse(
                            JSON.stringify(this.copied),
                        );
                    }
                });
                this.resetSelection();
                this.$store.dispatch("notification/success", {
                    text: this.t("notificationSchedule-success_paste"),
                    duration: 3000,
                });
            }
        },
        resetSelection() {
            this.resetTimeCopied();
            Object.keys(this.notification_schedule_selecteds).forEach(
                (day) => (this.notification_schedule_selecteds[day] = false),
            );
            this.notification_schedule_select_all = false;
        },
    },
    created: function () {
        document.getElementsByTagName("title")[0].innerText =
            this.t("notificationSchedule-browser_title");
        this.getForm();
    },
};
</script>
